import { Box, Button, IconButton, Typography } from '@mui/material';
import { Fragment, useState } from 'react';
import {
  UpgradePlanLiteModalTexts,
  paths
} from 'src/common/config/TextMessage';
import { UpgradePlanLiteModalSxs } from './keywordResearchCSS';
import { useNavigate } from 'react-router';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackBarClose } from 'src/redux/keywordResearch';
import { RootState } from 'src/redux/store';
import { setIsOpenChangePlan } from 'src/redux/siteAuditReducer';
import CommonModal from 'src/common/config/CommonModal';
import { BuySearchCreditModal } from './BuySearchCreditModal';
import { handleInterComClick } from 'src/common/config/FunctionHelper';
import { GenerateIdeasLoader } from './blogPostIdeas/GenerateIdeasLoader';
export const UpgradePlanLiteModal = () => {
  const [openCreditModal, setOpenCreditModal] = useState(null);
  const [openCreditProcessModal, setOpenCreditProcessModal] = useState(false);
  const hide =
    useSelector((state: RootState) => state.keywordResearch.closeSnackBar) ??
    false;
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  const isMember = userDetails?.role_type === 'member';
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isAgency = activePlanName === planDetails?.agency;
  const isExpertPlus = activePlanName === planDetails?.expertPlus;
  const isDesigner = activePlanName === planDetails?.designer;
  const isEnterprise = activePlanName === planDetails?.enterprise;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleCloseCreditModal = () => {
    setOpenCreditModal(false);
  };

  const handleCloseProcessCreditModal = () => {
    setOpenCreditProcessModal(false);
  };

  return (
    <Fragment>
      <Box
        sx={{
          display: hide ? 'none' : 'flex',
          ...UpgradePlanLiteModalSxs?.mainBox
        }}
      >
        <Box>
          <Box sx={UpgradePlanLiteModalSxs?.headerBox}>
            <img
              src={
                process.env.PUBLIC_URL +
                `/static/images/icons/keyword/rocket_con.svg`
              }
              alt="icon"
            />
            <Box>
              <Typography sx={UpgradePlanLiteModalSxs?.headerText}>
                {/*{UpgradePlanLiteModalTexts?.header}*/}
                {isAgency || isExpertPlus || isEnterprise
                  ? UpgradePlanLiteModalTexts?.agencyHeader
                  : UpgradePlanLiteModalTexts?.kwHeader}
              </Typography>
              <Typography sx={UpgradePlanLiteModalSxs?.desc}>
                {/*{UpgradePlanLiteModalTexts?.desc}*/}
                {isAgency || isExpertPlus || isEnterprise
                  ? UpgradePlanLiteModalTexts?.agencyDesc
                  : UpgradePlanLiteModalTexts?.kwDesc}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={UpgradePlanLiteModalSxs?.btnBox}>
          {isDesigner && (
            <Button
              variant="outlined"
              onClick={() => {
                setOpenCreditModal(true);
              }}
              disableRipple
              sx={UpgradePlanLiteModalSxs?.btnCredits}
              disabled={isMember}
            >
              <Typography sx={UpgradePlanLiteModalSxs?.btnText}>
                {UpgradePlanLiteModalTexts?.buyCredits}
              </Typography>
            </Button>
          )}
          <Button
            onClick={() => {
              if (isEnterprise) {
                handleInterComClick();
              } else if (isAgency || isExpertPlus) {
                setOpenCreditModal(true);
              } else {
                dispatch(setIsOpenChangePlan(true));
                navigate(paths?.billing);
              }
            }}
            disableRipple
            sx={{
              ...UpgradePlanLiteModalSxs?.btn
            }}
            disabled={isMember}
          >
            <Typography sx={UpgradePlanLiteModalSxs?.btnText}>
              {isEnterprise
                ? UpgradePlanLiteModalTexts?.contactUs
                : isAgency || isExpertPlus
                ? UpgradePlanLiteModalTexts?.buySearchCredit
                : UpgradePlanLiteModalTexts?.upgradePlan}
            </Typography>
          </Button>
          <IconButton
            onClick={() => {
              dispatch(setSnackBarClose(true));
            }}
            disableRipple
            aria-label="close"
            sx={UpgradePlanLiteModalSxs?.closeIcon}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <CommonModal
        open={openCreditModal}
        handCloseModal={() => setOpenCreditModal(true)}
        title={''}
        closebtn={false}
        blur={false}
        isBuySearchCredit={true}
      >
        <BuySearchCreditModal
          handleCloseCreditModal={handleCloseCreditModal}
          handleCloseProcessCreditModal={handleCloseProcessCreditModal}
          setOpenCreditProcessModal={setOpenCreditProcessModal}
        />
      </CommonModal>
      <CommonModal
        open={openCreditProcessModal}
        handCloseModal={setOpenCreditProcessModal}
        title={''}
        closebtn={false}
        blur={false}
        isBuySearchCredit={false}
      >
        <GenerateIdeasLoader
          title={'Adding search credits...'}
        ></GenerateIdeasLoader>
      </CommonModal>
    </Fragment>
  );
};
